const WARM_UP_SUFFIX = "Warm-Up Challenge";

/**
 * How a report names a warm-up session: the set's name as the server sent it,
 * then "(Warm-Up Challenge)". Only the server knows a session was a warm-up,
 * so nothing but its `is_warm_up` flag is read.
 *
 * @param {object|null} session A session row.
 * @returns {string|null} The label, or null for any other session.
 */
export const warmUpLabel = (session) => {
  if (session?.is_warm_up !== true) return null;
  const name = session.warmup_set_name;
  return name == null ? WARM_UP_SUFFIX : `${name} (${WARM_UP_SUFFIX})`;
};
